// extracted by mini-css-extract-plugin
export var backLink = "index-module--backLink--c8WaH";
export var error = "index-module--error--o4zOg";
export var form = "index-module--form--4WdFp";
export var logo = "index-module--logo--tFm6X";
export var message = "index-module--message--oSmFi";
export var resetPage = "index-module--resetPage--bgV9g";
export var submitButton = "index-module--submitButton--guX3B";